/*
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2024-03-21 14:34:20
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/vant.js'
import '@/styles/index.scss'
import 'amfe-flexible'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
// 开发环境使用vConsole进行调试
if (process.env.NODE_ENV === 'development') {
  const VConsole = require('vconsole')
  new VConsole()
}
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
